<script>
    import { createEvent } from 'shared/eventBus';

    export default {
        props: {
            value: Boolean,
            name: String,
            disabled: Boolean,
            ariaLabelledby: String,
            ariaLabel: String
        },
        methods: {
            toggle() {
                if(!this.disabled) {
                    this.checked = !this.checked;
                    this.$emit('input', this.checked);
                }
            },
            check() {
                this.checked = true;
                this.$emit('input', true);
            },
            uncheck() {
                this.checked = false;
                this.$emit('input', false);
            },
            input(e) {
                var val = e.target.checked;
                this.$emit('input', val);
                this.$emit('change', val);
                
                this.$el.dispatchEvent(createEvent("change"));
            }
        },
        mounted() {
            this.checked = this.value;

            if(this.checked) {
                this.$refs.checkbox.checked = true;
            }

            //Bind to event so we can update v-model when deselected
            this.$root.$on(`${this.name}_selected`, (uid) => {
                if(uid !== this._uid){
                    if(this.checked) {
                        this.$emit('input', this.checked = false);
                    }
                }
            });
        },
        data() {
            return {
                checked: false
            };
        },
        watch: {
            value(val) {
                this.checked = val;
            },
            checked(val) {
                this.$emit('change', val);
                if(val) {
                    this.$emit('check', val);
                } else {
                    this.$emit('uncheck', val);
                }
            }
        }
    }
</script>

<template>
    <div class="checkbox-container" @keyup.enter="toggle">
        <input ref="checkbox" :disabled="disabled" type="checkbox" :aria-label="ariaLabel" :aria-labelledby="ariaLabelledby"
            :name="name" v-model="checked" @change="input">
        <span class="checkmark"></span>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    @import "~less-mixins";

    .checkbox-container {
        display: block;
        position: relative;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        input {
            position: absolute;
            opacity: 0;

            &:checked {
                &~.checkmark {
                    background-color: #ffffff;

                    &:after {
                        display: block;
                    }
                }
            }
        }

        &:hover {
            input {
                &~.checkmark {
                    background-color: #ccc;
                }
            }
        }

        .checkmark {
            &:after {
                left: 6px;
                top: 2px;
                width: 5px;
                height: 10px;
                border: solid @frontier-green;
                border-width: 0 3px 3px 0;
                -webkit-transform: rotate(45deg);
                -ms-transform: rotate(45deg);
                transform: rotate(45deg);
                box-sizing: content-box;
            }
        }
    }

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #ffffff;
        border-radius: 2px;

        &:after {
            content: "";
            position: absolute;
            display: none;
        }
    }

    body.user-is-tabbing {
        .checkbox-container:focus-within {
            .checkmark {
                border: 4px solid #aaa;
                box-sizing: content-box;
            }
        }
    }
</style>